import { render, staticRenderFns } from "./RecordListPage.vue?vue&type=template&id=e097ac82"
import script from "./RecordListPage.vue?vue&type=script&lang=js"
export * from "./RecordListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports